// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js!../../css/ANewDialog.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, "#dialog-overlay.NoProjectsDialog-new-dialog .dialog-container{\r\n    height: 294px;\r\n    width: 500px;\r\n    max-width: calc(100% - 30px);\r\n}\r\n#dialog-overlay.NoProjectsDialog-new-dialog .dialog-content{\r\n    padding: 0;\r\n    height: calc(100% - 50px);\r\n}\r\n\r\n#dialog-overlay.NoProjectsDialog-new-dialog .page-back-btn{\r\n    display: none !important;\r\n}", ""]);
// Exports
module.exports = exports;
